import { fg } from '@confluence/feature-gating';

/**
 * Whether any meeting-signal consumer needs page content to be analysed.
 *
 * GAS v3 controls instrumentation, while the HT and LT gates control the two
 * nudge audiences. Keeping this check shared prevents callers from converting
 * ADF when every consumer is disabled.
 */
export const isMeetingSignalAnalysisEnabled = (): boolean =>
	fg('twcg-2202-gasv3') ||
	fg('twcg-2202-loom-meeting-nudge-ht-gate') ||
	fg('twcg-2202-loom-meeting-nudge-lt-gate');
